export default __webpack_public_path__ + "static/media/woolacombe.f21871be.jpg";